/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from "react";
import { Table, Label, Input } from 'reactstrap';
import { BankDetailConstants as Constants } from "../constants";

interface AccountingTable2CEProps {
    headers : string[], 
    data: any,
    totalLabel : string,
    totalAmount : string,
    idkey: string 
}

interface AccountingTable2CEState {
    data: any
} 

class AccountingTable2CE extends React.Component<AccountingTable2CEProps, AccountingTable2CEState> {

    constructor(props: AccountingTable2CEProps) {
        super(props);

        this.state = {
            data: this.props.data
        }

        this.onBlurHandler = this.onBlurHandler.bind(this);
    }

    onBlurHandler(event : React.ChangeEvent<HTMLInputElement>) {

        if( event && event.target )
        {
            const id : string = event.target.id + "error";
            // see if an error text already exisits
            let errorMessage : HTMLElement | null = document.getElementById(id);

            // remove any $ and commas
            const sAmount : string = ( event.target.value || "" ).replace(/\$|,/g, '');
            const iAmount : number = parseInt( sAmount );

            // check to see if an actuall integer number or that the sting 
            // amount does not equal the integer amount
            if( !Number.isInteger( iAmount ) || sAmount !== ( "" + iAmount ) ){
                // insert error
                if( errorMessage == null )
                {
                    errorMessage = document.createElement('span');
                    errorMessage.id = id;
                    errorMessage.appendChild( document.createTextNode("Invalid Amount") );
                    if( event.target.parentElement)
                    {
                        event.target.parentElement.insertBefore(errorMessage, event.target);
                        event.target.parentElement.className = "accountValueError";
                    }
                }

                // bubble error, just in case
                event.target.dispatchEvent(new CustomEvent('invalidAmountEvent', {
                    bubbles: true,
                    detail: { text: sAmount }
                }))
            }
            else
            {
                // check or error message and remove if there is one
                if( errorMessage !== null && event.target.parentElement) 
                {
                    event.target.parentElement.removeChild(errorMessage);
                    event.target.parentElement.className = "";
                }
            }
        }
    }

    formatAmount( amount : string ){
        amount = amount || "0"
        let dollarAmount : string = amount;
        if( amount !== "\u00A0" )
        {
            let numAmout = parseInt(amount); 
            let preN = ""; let postN = "";
            if( numAmout < 0 ) 
            {
                numAmout = Math.abs(numAmout);
                preN = "(";
                postN = ")";
            }
            dollarAmount = preN + numAmout.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + postN;
        }
        return dollarAmount;
    }

    render() {
        let that : any = this;
        const rows : any = this.state.data.map((row : any, key : any) =>
            <tr key={key} className={row.className} role={row.label === Constants.FILLER ? 'presentation' : "" }>
                <th scope="row">
                    {row.edit === true ? <Label for={that.props.idkey + key}>{row.label}</Label> : row.label}
                    {row.link !== "" ? <sup><a href={"#details" + row.link}>{"(" + row.link +")"}</a></sup> : "" }
                </th>
                <td>{row.edit === true ? 
                    <Input type="text" className="text-right" name={that.props.idkey + key} id={that.props.idkey + key} onBlur={that.onBlurHandler} defaultValue={row.amount}/> :
                    (key === 0 || ( row.label !== Constants.FILLER && ( key === 5 || key === 6) ) ? "$ " : "") + this.formatAmount(row.amount) }
                </td>
            </tr>
        );
        const hdr : any= this.props.headers[0] === 'Assets' ? <sup><a href={"#details1"}>(1)</a></sup> : null;
        return (
            <Table className="acctTable">
                <thead>
                    <tr>
                        <th scope="col">{this.props.headers[0]}{hdr}</th>
                        <th scope="col">{this.props.headers[1]}</th>
                    </tr>
                </thead>
                <tbody>
                    {rows}
                    <tr role="presentation"><td>&nbsp;</td><td>&nbsp;</td></tr>
                    <tr className="totalSumRow"><th scope="row">{this.props.totalLabel}</th><td>${this.formatAmount(this.props.totalAmount)}</td></tr>
                </tbody>
            </Table>
        );
    }
}

export default AccountingTable2CE;